import { Input, InputPropsStrict } from '@servicetitan/design-system';
import { ComponentProps, FC, useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import debounce from 'lodash/debounce';

export interface SearchFilterDebouncedProps
  extends Omit<ComponentProps<typeof Input>, 'onChange'> {
  onChange(value: string): void;
  delay?: number;
}

export const SearchFilterDebounced: FC<SearchFilterDebouncedProps> = ({
  delay = 300,
  onChange,
  value,
  className,
  ...props
}) => {
  const [inputValue, setInputValue] = useState(value ?? '');
  const changeValue = useMemo(
    () => debounce(onChange, delay),
    [onChange, delay],
  );

  useEffect(() => {
    setInputValue(value ?? '');
  }, [value]);

  const onChangeHandler: InputPropsStrict['onChange'] = (_, data) => {
    setInputValue(data.value);
    changeValue(data.value);
  };

  return (
    <Input
      size='small'
      icon='search'
      iconPosition='left'
      className={classNames('w-25', className)}
      {...props}
      onChange={onChangeHandler}
      value={inputValue}
      data-testid={props['data-testid']}
    />
  );
};
